<div class="navbar">
    <!-- This is the hamburger menu that triggers below 370px -->
    <div class="mobile-version__drawer-container">
        <button mat-button class="menu-button" (click)="sidenav.toggle()">
            <mat-icon>{{ isMenuOpen ? "menu_open" : "menu" }}</mat-icon>
        </button>
        <mat-sidenav-container class="sidenav-container">
            <mat-sidenav #sidenav autoFocus="false" mode="over" [(opened)]="isMenuOpen" class="sidenav"
                (click)="onSidenavClick()">
                <div class="drawer__buttons">
                    <mat-accordion>
                        <p *ngIf="permissionsService.hasPermission('monitoring-module.proiecte.list')"
                            routerLink="/proiecte" class="menu-link" [class.menu-active]="'/proiecte' === activeRoute"
                            (click)="setActiveRoute('/proiecte')">
                            <img src="../../../assets/icons/docs.svg" alt="" />
                            <span>Proiecte</span>
                        </p>
                        <p class="menu-link" routerLink="/push-notifications-proiecte"
                            [class.menu-active]="'/push-notifications-proiecte' === activeRoute"
                            (click)="setActiveRoute('/push-notifications-proiecte')">
                            <img src="../../../assets/icons/docs.svg" alt="" />
                            <span>Push Notifications Proiecte</span>
                        </p>
                        <p *ngIf="
                                permissionsService.hasPermission('monitoring-module.proiecte.categorii.list') ||
                                permissionsService.hasPermission('monitoring-module.proiecte.sectiuni.list') ||
                                permissionsService.hasPermission('monitoring-module.proiecte.tag.list') ||
                                permissionsService.hasPermission('monitoring-module.proiecte.provider.list') ||
                                permissionsService.hasPermission('monitoring-module.proiecte.agent.list') ||
                                permissionsService.hasPermission('monitoring-module.proiecte.motiv-delay.list') ||
                                permissionsService.hasPermission('monitoring-module.proiecte.proiecte-status.list')
                            " routerLink="/setari-proiecte" class="menu-link"
                            [class.menu-active]="'/setari-proiecte' === activeRoute"
                            (click)="setActiveRoute('/setari-proiecte')">
                            <img src="../../../assets/icons/setari.svg" alt="" />
                            <span>Setări Proiecte</span>
                        </p>

                        <!-- <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="../../../assets/icons/docs.svg" alt="" />
                                        <span>Proiecte</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p routerLink="/proiecte" class="settings-option-menu"
                                [class.menu-active]="'/proiecte' === activeRoute" (click)="setActiveRoute('/proiecte')">
                                <img src="../../../assets/icons/docs.svg" alt="" />
                                <span>Proiecte</span>
                            </p>
                            <p routerLink="/setari-proiecte" class="settings-option-menu"
                                [class.menu-active]="'/setari-proiecte' === activeRoute"
                                (click)="setActiveRoute('/setari-proiecte')">
                                <img src="../../../assets/icons/setari.svg" alt="" />
                                <span>Setări Proiecte</span>
                            </p>
                        </mat-expansion-panel> -->
                    </mat-accordion>

                    <div class="footer">
                        <div class="logout-button" (click)="logout()">
                            <img src="assets/icons/logout.svg" alt="Deconectare" />
                            <div class="logout-button--text">Deconectare</div>
                        </div>
                    </div>
                </div>
            </mat-sidenav>
            <mat-sidenav-content>
                <main>
                    <!-- <router-outlet></router-outlet> -->
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>

    <div class="username">{{ username }}</div>
    <div class="username__icon">
        <div class="username__icon--letters">{{ usernameLetters }}</div>
    </div>

    <div class="notification" [popover]="popTemplateNotifications" [adaptivePosition]="true"
        #notificationsPopover="bs-popover" placement="bottom" container="body" boundariesElement="scrollParent">
        <div class="notifications" [ngClass]="{ 'move-up': !userNotifications && !isLoading }">
            <mat-spinner color="primary" diameter="40" *ngIf="isLoading"></mat-spinner>
            <img src="assets/icons/icon-bell.svg" alt="Notificari" />
            <div class="notifications--chip" [ngClass]="{ 'hide-chip': isLoading }">
                <span *ngIf="!isLoading && userNotifications">{{ userNotifications }}</span>
            </div>
        </div>

    </div>

    <ng-template #popTemplateNotifications>
        <p class="title">Aveți {{ userNotifications }} notificări</p>
        <div class="notification-popup d-flex flex-column">
            <div class="notification-message-container">
                <button type="button"
                    class="btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '1', name: 'Proiecte'})">
                    <i class="fa-solid fa-envelope info"></i> {{notification['monitoring_messages_not_assigned']}}
                    Mesaje trimise în atenția dvs.
                </button>

                <button type="button"
                    class="btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '2', name: 'Mesaje interne'})">
                    <i class="fa-solid fa-triangle-exclamation warning"></i>
                    {{notification['monitoring_messages_assigned']}}
                    Mesaje interne pentru proiectele dvs.
                </button>
            </div>
        </div>
    </ng-template>
</div>